/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Load_BodyInputs */

const en_us2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simply the heaviest weight you have used in a set of this exercise, for any number of reps. With dumbbells, it is also the weight of one dumbbell.`)
};

const pt_br2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É só o peso mais alto que você já usou numa série deste exercício, com qualquer número de repetições. Com halteres, também vale o peso de um halter.`)
};

const es_419_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simplemente el peso más alto que has usado en una serie de este ejercicio, con cualquier número de repeticiones. Con mancuernas, también es el peso de una mancuerna.`)
};

const pt_pt2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É simplesmente o peso mais alto que já usaste numa série deste exercício, com qualquer número de repetições. Com halteres, também conta o peso de um haltere.`)
};

const fr_fr2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simplement la charge la plus lourde que tu as utilisée sur une série de cet exercice, quel que soit le nombre de répétitions. Avec des haltères, c'est aussi le poids d'un seul haltère.`)
};

const de_de2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfach das höchste Gewicht, das du in einem Satz dieser Übung genutzt hast, bei beliebig vielen Wiederholungen. Bei Kurzhanteln zählt auch hier das Gewicht einer Hantel.`)
};

const it_it2_exercise_personal_info_load_body = /** @type {(inputs: Exercise_Personal_Info_Load_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semplicemente il peso più alto che hai usato in una serie di questo esercizio, con qualsiasi numero di ripetizioni. Con i manubri conta sempre il peso di un manubrio.`)
};

/**
* | output |
* | --- |
* | "Simply the heaviest weight you have used in a set of this exercise, for any number of reps. With dumbbells, it is also the weight of one dumbbell." |
*
* @param {Exercise_Personal_Info_Load_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_load_body = /** @type {((inputs?: Exercise_Personal_Info_Load_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Load_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_load_body(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_load_body(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_load_body(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_load_body(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_load_body(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_load_body(inputs)
	return en_us2_exercise_personal_info_load_body(inputs)
});
export { exercise_personal_info_load_body as "exercise-personal.info_load_body" }